import { useSubscribeUnlockDialogListener } from '@lingoda/subscriptions';
import {
    useGoalAchievedCelebrationDialog,
    useSetGoalDialogWeeklyClasses,
} from '@lingoda/student-achievements';
import { useYearlyRecapDialog } from '@lingoda/student-yearly-recap';
import { usePostFFreeTrialDialog } from '@lingoda/student-f-free-trial';

export const useDialogsTriggers = () => {
    useSubscribeUnlockDialogListener();
    useSetGoalDialogWeeklyClasses();
    useGoalAchievedCelebrationDialog();
    useYearlyRecapDialog();
    usePostFFreeTrialDialog();
};
